// extracted by mini-css-extract-plugin
export default {"container":"styles_container__9l-mW","item":"styles_item__wKtt9","title":"styles_title__vw+kZ"};